<script setup lang="ts">
import type { BasicPropsType, ResponsivePropsType } from '@/components/goat/form/compositions/FieldsUtils'
import { BasicPropsDefaults, getFieldModel, ResponsivePropsDefaults } from '@/components/goat/form/compositions/FieldsUtils'

interface CustomeProps {
  labelCheckBox?: string
}
withDefaults(defineProps<BasicPropsType & ResponsivePropsType & CustomeProps>(), { ...BasicPropsDefaults, ...ResponsivePropsDefaults })
defineEmits(['change'])
</script>

<template>
  <goat-form-field-wrapper v-bind="$props">
    <template #default="{ form }">
      <el-checkbox
        v-model="getFieldModel(form, apiFieldName).value"
        v-bind="$attrs"
        :label="labelCheckBox"
        @change="$emit('change', $event)"
      >
        <template
          v-if="$slots.label"
          #default
        >
          <slot
            name="label"
          />
        </template>
      </el-checkbox>
    </template>
  </goat-form-field-wrapper>
</template>

<style scoped lang="postcss">

</style>
